export const TARReducerName = 'tar';
export const PayrollContactEmail = 'payroll@microsoft.com';
